import React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { ROUTES } from './routePaths'

// The Inbox was split into /chat and /notifications; push notifications and bookmarks still
// point at /inbox/* — map every legacy path to its new home, preserving the query string
// (?isPush) and location state so deep-link behavior stays identical.
export default function LegacyInboxRedirect(
  props: RouteComponentProps<{ notificationId?: string; channelKind?: string; channelId?: string }>,
) {
  const { match, location } = props
  const { notificationId, channelKind, channelId } = match.params

  let pathname = ROUTES.CHAT.to
  if (channelKind && channelId) {
    pathname = `${ROUTES.CHAT.to}/${channelKind}/${channelId}`
  } else if (!notificationId || notificationId === 'chat') {
    pathname = ROUTES.CHAT.to
  } else if (notificationId === 'announcements' || notificationId === 'notifications') {
    pathname = ROUTES.NOTIFICATIONS.to
  } else if (notificationId === 'preferences') {
    pathname = ROUTES.NOTIFICATION_SETTINGS.to
  } else {
    pathname = `${ROUTES.NOTIFICATIONS.to}/${notificationId}`
  }

  return <Redirect to={{ pathname, search: location.search, state: location.state }} />
}
